<template>
  <div class="wrap">
    <a class="logo_icon toAuto" href="/"><img src="@/assets/image/logo-white.svg"></a>
    <h2 class="txtCon write">404</h2>
    <p class="txtCon write">您正在访问另一个平行时空中的页面，泛函在非常努力的解决通信问题，或许您可以先尝试返回首页</p>
    <div class="txtCon">
      <a class="btn404 toAuto" href="/">返回首页</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'page2',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
  html{height: 100%;}
  body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,button,textarea,p,blockquote,th,td { margin:0; padding:0; }
  body { background:#5788CD; color:#555; font-size:1em; font-family: Verdana, Arial, Helvetica, sans-serif; }
  td,th,caption { font-size:1em; }
  h1, h2, h3, h4, h5, h6 { font-weight:normal; font-size:100%; }
  address, caption, cite, code, dfn, em, strong, th, var { font-style:normal; font-weight:normal;}
  a { color:#555; text-decoration:none; }
  a:hover { text-decoration:underline; }
  img { border:none; }
  ol,ul,li { list-style:none; }
  input, textarea, select, button { font:1em Verdana,Helvetica,Arial,sans-serif; }
  table { border-collapse:collapse; }
  .clearfix:after {content: "."; display: block; height:0; clear:both; visibility: hidden;}
  .clearfix { *zoom:1; }
  /*state*/
  .wrap{
    position: absolute;
      top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background:url('~@/assets/image/404/img32.jpg');
    background-size: cover;
  }
  a{
    display: block;
  }
  a:hover{
    text-decoration: none;
  }
  .write{
    color: #fff;
  }
  .txtCon{
    text-align: center;
  }
  .toAuto{
    margin-left: auto;
    margin-right: auto;
  }
  .logo_icon{
    width: 3.75em;
    margin-top: 3.125em;
    margin-bottom:5em;
  }
  .logo_icon img{
    width: 100%;
  }
  .wrap h2{
    font-size: 5em;
    line-height: 1.1;
  }
  .wrap p{
    font-size: .875em;
    line-height: 2;
    margin: 15px .9375em;
  }
  .btn404{
    color: #fff;
    background-color: #0983ff;
    border-color: #0983ff;
    padding: 0 30px;
    font-size: .875em;
    line-height: 3em;
    -webkit-transition: all .15s;
    transition: all .15s;
    border-radius: 4px;
    font-weight: 500;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    margin-top: 5em;
  }
  .btn404:hover{
    background-color: #0771dc;
  }
</style>
